// What the inline column editor and the forecast column say to each other.
//
// Both are Stimulus controllers on the report page's `<body>` (see
// ReportsController#setup_report_show_state) and neither owns the other's DOM: the
// drawer needs to know a forecast column is there so it can list it, and the
// forecast column needs to know when the drawer has replaced the table under it.
// Plain document events rather than one controller reaching for the other, and
// named here so both sides spell them the same way.
export const COLUMN_EDITOR_OPENED = 'reports:column-editor-opened'
export const COLUMN_EDITOR_CLOSED = 'reports:column-editor-closed'

// The drawer has just put a freshly rendered report table on the page.
export const COLUMN_EDITOR_APPLIED = 'reports:column-editor-applied'

// Which year the report's forecast column is forecasting, or null when there is
// no forecast on it. Sent in answer to the drawer opening, and when a forecast
// is cleared — the only change that can happen under an open drawer.
export const FORECAST_CHANGED = 'reports:forecast-changed'

export interface ForecastChangedDetail {
  year: number | null
}
